export default __webpack_public_path__ + "static/media/insta_ui.6d575fd7.PNG";